export default __webpack_public_path__ + "static/media/logo-yclick-2.52a6fde3.svg";